import dayjs from 'dayjs'
import { businessTimeZone } from '../../../utils/date'

// WS 2311820. What the profile badge (FinancingStatusBadge) and the Customers-list row chip share:
// the day count, when it turns red, the colours and the icon.
export const OVERDUE_DAYS = 5

// Calendar days from the signing day to today, both in business time.
export const daysSince = (value) => {
  const start = dayjs.utc(value).tz(businessTimeZone).startOf('day')
  const today = dayjs().tz(businessTimeZone).startOf('day')
  return Math.max(0, today.diff(start, 'day'))
}

export const STYLES = {
  pending: 'bg-warning-light text-warning-main',
  overdue: 'bg-error-light text-error-main',
  marked: 'bg-info-light text-info-main',
  paid: 'bg-success-light text-success-main',
  unmarked: 'border border-divider text-text-secondary',
}

export const CHIP = 'inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-bold whitespace-nowrap'

// A bank: the lender pays.
export const FinancingIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 10h18" />
    <path d="M5 10v8M9.5 10v8M14.5 10v8M19 10v8" />
    <path d="M3 21h18" />
    <path d="M12 3l9 5H3z" />
  </svg>
)

// Pending: "Financing pending", red "Not funded" from OVERDUE_DAYS, and the day it is on.
export const pendingLook = (since) => {
  const days = daysSince(since)
  const overdue = days >= OVERDUE_DAYS
  return { title: overdue ? 'Not funded' : 'Financing pending', day: `day ${days}`, style: overdue ? STYLES.overdue : STYLES.pending }
}

// Read-only, for the list row: the profile's badge without the actions.
export const FinancingRowChip = ({ financingState }) => {
  if (!financingState) return null

  const { state, financed, since } = financingState
  const pending = state === 'pending' && pendingLook(since)
  const look = pending
    ? { text: `${pending.title} · ${pending.day}`, style: pending.style }
    : state === 'paid'
      ? { text: 'Financed · paid', style: STYLES.paid }
      : financed ? { text: 'Financing', style: STYLES.marked } : null
  if (!look) return null

  return (
    <span className={`${CHIP} text-[11px] ${look.style}`}>
      <FinancingIcon />
      {look.text}
    </span>
  )
}
